import { render, staticRenderFns } from "./accountMenu.vue?vue&type=template&id=c038e338&scoped=true&"
import script from "./accountMenu.vue?vue&type=script&lang=js&"
export * from "./accountMenu.vue?vue&type=script&lang=js&"
import style0 from "./accountMenu.vue?vue&type=style&index=0&id=c038e338&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c038e338",
  null
  
)

export default component.exports